import React from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import logoblanco from "../../../img/solimat-logo-blanco.svg";
import phone from "../../../img/07.svg";
import wcagIcon from "../../../img/wcag2.1AA.png";

import './FooterNew.scss';

interface IFooterNewProps {
  dataSource: any;
}

const FooterNew: React.FC<IFooterNewProps> = ({ dataSource }) => {
  return (
    <footer className="footer-new-block">
      <div className="footer-new-content">
        <div className="container">
          <div className="footer-new-row">
            <div className="footer-new-logo">
              <img className="logo-new" src={logoblanco} alt="solimat" />
            </div>

            <div className="footer-new-tel">
              <a href="tel:900111072" className="tel-new-link">
                <span className="tel-new-icon">
                  <img src={phone} alt="" />
                </span>
                <span className="tel-new-info">
                  <span className="tel-new-title">Teléfono Urgencias:</span>
                  <span className="tel-new-number">900 111 072</span>
                </span>
              </a>
            </div>

            <nav className="footer-new-nav" aria-label="Navegación del pie de página">
              {dataSource.map((item: any, i: number) => (
                <NavLink to={item.path} className="nav-new_link" key={i}>
                  {item.text}
                </NavLink>
              ))}
              <Link to="/mis-encuestas" className="nav-new_link">
                Encuestas
              </Link>
              <Link to="/red-de-centros" className="nav-new_link">
                Red de centros
              </Link>
              <Link to="/declaracion-de-accesibilidad" className="nav-new_link nav-new_link--accessibility">
                <img
                  height="32"
                  width="88"
                  src={wcagIcon}
                  alt="Icono de conformidad con el Nivel Doble-A de las Directrices de Accesibilidad para el Contenido Web 2.1 del W3C-WAI"
                />
                Declaración de accesibilidad
              </Link>
            </nav>
          </div>
        </div>
      </div>
      <p className="footer-new-copy">
        <small>&copy; Solimat. Todos los derechos reservados.</small>
      </p>
    </footer>
  );
};

export default FooterNew;
